type UtmParams = {
  utm_source: string;
  utm_medium: string | null;
  utm_campaign: string | null;
  utm_term: string | null;
  utm_content: string | null;
};

const UTM_SEARCH_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;

const mapToUtmParams = (
  obj: Record<string, unknown>,
): UtmParams | undefined => {
  // Check if utm_source exists and is a string (required field)
  if (!obj["utm_source"] || typeof obj["utm_source"] !== "string") {
    return undefined;
  }

  // Map the object to UtmParams structure
  return {
    utm_source: obj["utm_source"],
    utm_medium:
      typeof obj["utm_medium"] === "string" ? obj["utm_medium"] : null,
    utm_campaign:
      typeof obj["utm_campaign"] === "string" ? obj["utm_campaign"] : null,
    utm_term: typeof obj["utm_term"] === "string" ? obj["utm_term"] : null,
    utm_content:
      typeof obj["utm_content"] === "string" ? obj["utm_content"] : null,
  };
};

export const getUtmParamsFromCookies = () => {
  const cookies = document.cookie.split(";");
  const utmParamsRecord: Record<string, unknown> = {};

  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split("=");
    if (UTM_SEARCH_KEYS.includes(name as (typeof UTM_SEARCH_KEYS)[number])) {
      try {
        utmParamsRecord[name] = decodeURIComponent(value);
      } catch (e) {
        console.error("Failed to parse UTM cookie:", e);
      }
    }
  }
  return mapToUtmParams(utmParamsRecord);
};

export const expireUtmParamsCookie = () => {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split("=");
    if (UTM_SEARCH_KEYS.includes(name as (typeof UTM_SEARCH_KEYS)[number])) {
      try {
        // Expire the cookie, which is the same as removing it
        document.cookie = `${name}=${value}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      } catch (e) {
        console.error("Failed to parse UTM cookie:", e);
      }
    }
  }
};
